import axios from 'axios';
import { PHP_BACK } from './Common';
//ruta base para conectarse al servidor de backed

//crea una instancia de axios para conectarse a la url base, acepta argumentos para poder agregar los endpoints después
export const backendApi = axios.create({
    baseURL: PHP_BACK,
    timeout: 300000,
});
